import { defaultSxProp } from '../utils/defaultSxProp.js';
import { isElement } from 'react-is';
import classes from './SegmentedControl.module.css.js';
import { clsx } from 'clsx';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const SegmentedControlButton = ({
  children,
  leadingIcon: LeadingIcon,
  selected,
  sx: sxProp = defaultSxProp,
  className,
  // Note: this value is read in the `SegmentedControl` component to determine which button is selected but we do not need to apply it to an underlying element
  defaultSelected: _defaultSelected,
  ...rest
}) => {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: "li",
    sx: sxProp,
    className: clsx(classes.Item),
    "data-selected": selected ? '' : undefined,
    children: /*#__PURE__*/jsx(BoxWithFallback, {
      as: "button",
      "aria-current": selected,
      className: clsx(classes.Button, className),
      type: "button",
      ...rest,
      children: /*#__PURE__*/jsxs("span", {
        className: clsx(classes.Content, 'segmentedControl-content'),
        children: [LeadingIcon && /*#__PURE__*/jsx("div", {
          className: classes.LeadingIcon,
          children: isElement(LeadingIcon) ? LeadingIcon : /*#__PURE__*/jsx(LeadingIcon, {})
        }), /*#__PURE__*/jsx("div", {
          className: clsx(classes.Text, 'segmentedControl-text'),
          "data-text": children,
          children: children
        })]
      })
    })
  });
};
SegmentedControlButton.displayName = "SegmentedControlButton";

export { SegmentedControlButton as default };
